<template>
  <div class="p-6">
    <!-- Actions -->
    <div class="mb-4 no-print">
      <button
        @click="printInvoice"
        class="btn-primary bg-blue-600 text-white px-4 py-2 rounded"
      >
        🖨️ Print Invoice
      </button>
    </div>

    <!-- Printable Section -->
    <div
      ref="printSection"
      class="invoice-container bg-white p-8 shadow rounded"
    >
      <h2 class="text-2xl font-bold mb-6 text-center">
        Invoice #{{ invoice.invoice_number }}
      </h2>

      <div class="grid grid-cols-2 gap-4 mb-6">
        <p>
          <b>Patient:</b> {{ invoice.patient_name }} ({{
            invoice.patient_number
          }})
        </p>
        <p><b>Age:</b> {{ invoice.age }}</p>
        <p><b>Visit Type:</b> {{ invoice.visit_type }}</p>
        <p><b>Insurer:</b> {{ invoice.insurer_name }}</p>
        <p><b>Visit Date:</b> {{ invoice.visit_date }}</p>
        <!-- 👈 Added here -->
      </div>

      <h3 class="mt-4 font-bold mb-2">Invoice Details</h3>
      <table class="w-full border-collapse border text-sm">
        <thead>
          <tr class="bg-gray-200">
            <th class="border p-2">Service / Product</th>
            <th class="border p-2">Quantity</th>
            <th class="border p-2">Unit Price</th>
            <th class="border p-2">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in invoice.items" :key="item.id">
            <td class="border p-2">{{ item.service_name }}</td>
            <td class="border p-2 text-center">{{ item.quantity }}</td>
            <td class="border p-2 text-right">{{ item.unit_price }}</td>
            <td class="border p-2 text-right">{{ item.amount }}</td>
          </tr>
        </tbody>
      </table>

      <div class="flex justify-end mt-6">
        <p class="font-bold text-lg">Total: {{ invoice.total_amount }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "InvoiceView",
  data() {
    return { invoice: { items: [] } };
  },
  methods: {
    async call_data() {
      const res = await generalApiRequest(
        "invoices/offcourse/view/" + this.$route.params.id,
        "GET",
        {},
        1
      );
      this.invoice = res;
    },
    printInvoice() {
      const content = this.$refs.printSection.innerHTML;
      const printWindow = window.open("", "_blank", "width=800,height=600");
      printWindow.document.write(`
        <html>
          <head>
            <title>Invoice</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; }
              h2 { text-align: center; }
              table { width: 100%; border-collapse: collapse; margin-top: 10px; }
              th, td { border: 1px solid #000; padding: 8px; }
              th { background: #f0f0f0; }
              .text-right { text-align: right; }
              .text-center { text-align: center; }
              .total { font-weight: bold; margin-top: 20px; text-align: right; }
            </style>
          </head>
          <body>
            ${content}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    },
  },
  mounted() {
    this.call_data();
  },
};
</script>

<style>
/* Hide buttons when printing */
@media print {
  .no-print {
    display: none !important;
  }
  .invoice-container {
    box-shadow: none !important;
    border: none !important;
    padding: 0 !important;
  }
}
</style>
